import api from '@api';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { getOrderExpeditionPackagesGridFetchSuccess, getOrderExpeditionPackagesGridFetchFailure } from './reducer';
import { OrderExpeditionPackagesGridResType } from 'src/types/orderExpeditionPackagesGrid';
import { GridRequestType } from 'src/types/table';
import { RootStoreType } from 'src/types/store';

export const ORDER_EXPEDITION_PACKAGE_GRID_URL = 'api/secure/order-expedition-packages/grid';
export const ORDER_EXPEDITION_PACKAGE_PRODUCTS_URL = 'api/secure/order-expedition-packages/packagesProducts';

export interface GetOrderExpeditionPackageGridCallPayloadType {
    params: GridRequestType;
}

const getOrderExpeditionPackagesGridFetchRequest = async (payload: GetOrderExpeditionPackageGridCallPayloadType) => {
    const res = await api('post', ORDER_EXPEDITION_PACKAGE_GRID_URL, payload.params);
    return res.data.data;
};

function* getOrderExpeditionPackagesGridFetch(action: {
    type: string;
    payload?: GetOrderExpeditionPackageGridCallPayloadType;
}) {
    try {
        let payloadData: GetOrderExpeditionPackageGridCallPayloadType | undefined = action.payload;
        if (!payloadData) {
            const params: GridRequestType = yield select(
                (state: RootStoreType) => state.orderExpeditionPackagesGrid.data?.request
            );
            if (params) {
                payloadData = {
                    params,
                };
            }
        }
        if (payloadData) {
            const response: OrderExpeditionPackagesGridResType = yield call((): any =>
                // @ts-ignore
                getOrderExpeditionPackagesGridFetchRequest(payloadData)
            );
            yield put(getOrderExpeditionPackagesGridFetchSuccess(response));
        } else {
            yield put(getOrderExpeditionPackagesGridFetchFailure({ error: null }));
        }
    } catch (error) {
        yield put(getOrderExpeditionPackagesGridFetchFailure({ error }));
    }
}

export function* getOrderExpeditionPackagesGridFetchWatch() {
    yield takeEvery(
        'orderExpeditionPackagesGrid/getOrderExpeditionPackagesGridFetch',
        getOrderExpeditionPackagesGridFetch
    );
}
